import {
  createFileRoute,
  useNavigate,
  useLocation
} from '@tanstack/react-router'
import Comment from '../../../../../../../../../../../../../containers/pin-details/components/task-list/task/comment/index.jsx'

function EditCommentRouteComponent() {
  const navigate = useNavigate()
  const location = useLocation()

  const handleClose = () => {
    const taskDetailsPath = location.pathname.replace(
      /\/edit-comment\/[^/]+\/?$/,
      ''
    )
    navigate({ to: taskDetailsPath, search: (prev) => prev })
  }

  return <Comment onClose={handleClose} />
}

export const Route = createFileRoute(
  '/_authenticated/project/$projectId/pins/$viewType/$planId/$pinId/task/task-details/$taskId/edit-comment/$id/'
)({
  component: EditCommentRouteComponent
})
